import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import useIsMobile from "../hooks/useIsMobile";

const NAV_GROUPS = [
  {
    label: "Persoane Fizice",
    links: [
      { to: "/contract-inchiriere", label: "Contract de Închiriere" },
      { to: "/act-aditional-inchiriere", label: "Act Adițional Închiriere" },
      { to: "/notificare-reziliere", label: "Notificare Reziliere" },
      { to: "/contract-comodat", label: "Contract de Comodat" },
      { to: "/contract-imprumut", label: "Contract de Împrumut" },
      { to: "/contract-vanzare-auto", label: "Contract Vânzare-Cumpărare Auto" },
    ],
  },
  {
    label: "Firme & Freelanceri",
    links: [
      { to: "/contract-prestari-servicii", label: "Contract Prestări Servicii" },
      { to: "/contract-colaborare-pfa", label: "Contract Colaborare PFA" },
      { to: "/nda", label: "NDA — Acord de Confidențialitate" },
    ],
  },
];

function DesktopDropdown({ group, isActive, location }) {
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef(null);
  const containerRef = useRef(null);

  const hasActiveLink = group.links.some(
    (l) => location.pathname === l.to || location.pathname.startsWith(l.to + "/")
  );

  function handleEnter() {
    clearTimeout(timeoutRef.current);
    setOpen(true);
  }

  function handleLeave() {
    timeoutRef.current = setTimeout(() => setOpen(false), 150);
  }

  return (
    <div
      ref={containerRef}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      style={{ position: "relative" }}
    >
      <button
        onClick={() => setOpen((v) => !v)}
        style={{
          background: "none",
          border: "none",
          fontSize: "13px",
          fontWeight: 600,
          color: hasActiveLink ? "#e8a88a" : "#b8a890",
          padding: "14px 14px",
          cursor: "pointer",
          borderBottom: hasActiveLink ? "2px solid #c45d3e" : "2px solid transparent",
          transition: "all 0.2s ease",
          fontFamily: "inherit",
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
        onMouseEnter={(e) => {
          if (!hasActiveLink) e.currentTarget.style.color = "#fdfbf7";
        }}
        onMouseLeave={(e) => {
          if (!hasActiveLink) e.currentTarget.style.color = "#b8a890";
        }}
      >
        {group.label}
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" style={{ transition: "transform 0.2s", transform: open ? "rotate(180deg)" : "none" }}>
          <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: "0",
            minWidth: "240px",
            backgroundColor: "#2a2115",
            border: "1px solid rgba(184, 168, 144, 0.2)",
            borderRadius: "8px",
            padding: "6px 0",
            boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
            zIndex: 100,
          }}
        >
          {group.links.map((link) => {
            const linkActive = location.pathname === link.to || location.pathname.startsWith(link.to + "/");
            return (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                style={{
                  display: "block",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: linkActive ? "#e8a88a" : "#b8a890",
                  textDecoration: "none",
                  padding: "10px 16px",
                  transition: "all 0.15s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(184, 168, 144, 0.1)";
                  if (!linkActive) e.currentTarget.style.color = "#fdfbf7";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  if (!linkActive) e.currentTarget.style.color = "#b8a890";
                }}
              >
                {link.label}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}

function MobileAccordion({ group, location }) {
  const [open, setOpen] = useState(false);

  const hasActiveLink = group.links.some(
    (l) => location.pathname === l.to || location.pathname.startsWith(l.to + "/")
  );

  return (
    <div>
      <button
        onClick={() => setOpen((v) => !v)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          background: "none",
          border: "none",
          fontSize: "14px",
          fontWeight: 600,
          color: hasActiveLink ? "#e8a88a" : "#b8a890",
          textDecoration: "none",
          padding: "12px 24px",
          borderLeft: hasActiveLink ? "3px solid #c45d3e" : "3px solid transparent",
          cursor: "pointer",
          fontFamily: "inherit",
          textAlign: "left",
        }}
      >
        {group.label}
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" style={{ transition: "transform 0.2s", transform: open ? "rotate(180deg)" : "none", flexShrink: 0 }}>
          <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <div
        style={{
          overflow: "hidden",
          maxHeight: open ? `${group.links.length * 44}px` : "0",
          transition: "max-height 0.3s ease",
        }}
      >
        {group.links.map((link) => {
          const linkActive = location.pathname === link.to || location.pathname.startsWith(link.to + "/");
          return (
            <Link
              key={link.to}
              to={link.to}
              style={{
                display: "block",
                fontSize: "13px",
                fontWeight: 600,
                color: linkActive ? "#e8a88a" : "rgba(184, 168, 144, 0.7)",
                textDecoration: "none",
                padding: "10px 24px 10px 40px",
                borderLeft: linkActive ? "3px solid #c45d3e" : "3px solid transparent",
                transition: "all 0.2s ease",
              }}
            >
              {link.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default function NavBar() {
  const isMobile = useIsMobile();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      style={{
        background: "#231c12",
        fontFamily: "'DM Sans', sans-serif",
        borderBottom: "1px solid rgba(184, 168, 144, 0.15)",
        position: "relative",
        zIndex: 50,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: isMobile ? "12px 16px" : "0 24px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Link
          to="/"
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "18px",
            fontWeight: 800,
            color: "#fdfbf7",
            textDecoration: "none",
            flexShrink: 0,
            padding: isMobile ? "0" : "14px 0",
          }}
        >
          ContractGen
        </Link>

        {isMobile ? (
          <button
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label={menuOpen ? "Inchide meniul" : "Deschide meniul"}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "4px",
              display: "flex",
              flexDirection: "column",
              gap: menuOpen ? "0px" : "5px",
              justifyContent: "center",
              alignItems: "center",
              width: "32px",
              height: "32px",
            }}
          >
            <span
              style={{
                display: "block",
                width: "22px",
                height: "2px",
                backgroundColor: "#b8a890",
                borderRadius: "1px",
                transition: "all 0.3s ease",
                transform: menuOpen ? "rotate(45deg) translate(1px, 1px)" : "none",
              }}
            />
            <span
              style={{
                display: "block",
                width: "22px",
                height: "2px",
                backgroundColor: "#b8a890",
                borderRadius: "1px",
                transition: "all 0.3s ease",
                opacity: menuOpen ? 0 : 1,
              }}
            />
            <span
              style={{
                display: "block",
                width: "22px",
                height: "2px",
                backgroundColor: "#b8a890",
                borderRadius: "1px",
                transition: "all 0.3s ease",
                transform: menuOpen ? "rotate(-45deg) translate(1px, -1px)" : "none",
              }}
            />
          </button>
        ) : (
          <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
            {NAV_GROUPS.map((group) => (
              <DesktopDropdown key={group.label} group={group} location={location} />
            ))}
            <Link
              to="/blog"
              style={{
                fontSize: "13px",
                fontWeight: 600,
                color: location.pathname.startsWith("/blog") ? "#e8a88a" : "#b8a890",
                textDecoration: "none",
                padding: "14px 14px",
                borderBottom: location.pathname.startsWith("/blog") ? "2px solid #c45d3e" : "2px solid transparent",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                if (!location.pathname.startsWith("/blog")) e.currentTarget.style.color = "#fdfbf7";
              }}
              onMouseLeave={(e) => {
                if (!location.pathname.startsWith("/blog")) e.currentTarget.style.color = "#b8a890";
              }}
            >
              Blog
            </Link>
          </div>
        )}
      </div>

      {/* Mobile dropdown menu */}
      {isMobile && (
        <div
          style={{
            overflow: "hidden",
            maxHeight: menuOpen ? "600px" : "0",
            transition: "max-height 0.3s ease",
            borderTop: menuOpen ? "1px solid rgba(184, 168, 144, 0.15)" : "none",
          }}
        >
          <div style={{ padding: "8px 0" }}>
            {NAV_GROUPS.map((group) => (
              <MobileAccordion key={group.label} group={group} location={location} />
            ))}
            <Link
              to="/blog"
              style={{
                display: "block",
                fontSize: "14px",
                fontWeight: 600,
                color: location.pathname.startsWith("/blog") ? "#e8a88a" : "#b8a890",
                textDecoration: "none",
                padding: "12px 24px",
                borderLeft: location.pathname.startsWith("/blog") ? "3px solid #c45d3e" : "3px solid transparent",
                transition: "all 0.2s ease",
              }}
            >
              Blog
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
